import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    overflow: 'auto',
    height: '100%',
    '& table': {
      overflowX: 'auto',
    },
    '& thead': {
      position: 'sticky',
      top: 0,
      '& th': {
        backgroundColor: theme.palette.mode === Mode.Dark ? undefined : '#f4f4f4'
      }
    },
  },
  tableRow: {
    display: 'flex !important',
  },
  tableCell: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex !important',
    justifyContent: 'flex-start',
    alignItems: 'center',
    wordBreak: 'break-word',
    maxHeight: '65px',
    height: '65px',
    overflow: 'hidden',
  },
  tableRowAligned: {
    alignItems: 'center',
  },
  tableBody: {
    overflow: 'auto',
    '@media (max-width: 700px)': {
      width: '1200px',
      overflowX: 'auto',
    },
  },
  table: {
    height: '100%',
    flexDirection: 'column',
    gridTemplateRows: '60px 1fr 60px',
  },
  disabled: {
    display: 'flex',
    alignItems: 'flex-end',
    '& > svg': {
      cursor: 'pointer',
      '& > path': {
        fill: 'lightgrey',
      },
    },
  },
  active: {
    display: 'flex',
    alignItems: 'flex-end',
    '& > svg': {
      cursor: 'pointer',
      '& > path': {
        fill: 'black',
      },
    },
  },
  checkIcon: {
    width: '25px',
    height: '25px',
    '& > path': {
      fill: theme.palette.mode === Mode.Light ? 'green' : '#81C784',
    },
  },
  crossIcon: {
    width: '25px',
    height: '25px',
    '& > path': {
      fill: theme.palette.mode === Mode.Light ? 'red' : '#E57373',
    },
  },
}));

export default useStyles;
